import React from 'react'
import { Link } from 'react-router-dom'

const FilterItem = ({
    filterId,
    itemName,
    className,
    active,
    sortValue
}) => (
    <li className={'filter-item' + className + ' ' + filterId}>
        {active ? (
            <Link className={"theme-radius-buttons-full filter-button text-light" + (active ? '' : ' filter-inactive')} data-fsk={itemName} to={{search: sortValue}}>{itemName}</Link>
        ) : (
            <span className={"theme-radius-buttons-full filter-button text-light" + (active ? '' : ' filter-inactive')}>{itemName}</span>
        )}
    </li>

)

export default FilterItem